import { render } from "./IndexForm.vue?vue&type=template&id=10f0f2e2&ts=true"
import script from "./IndexForm.vue?vue&type=script&lang=ts"
export * from "./IndexForm.vue?vue&type=script&lang=ts"

import "./IndexForm.vue?vue&type=style&index=0&id=10f0f2e2&lang=css"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__